import React from "react";
import "../../stylesheets/odometerAlert.scss";

const OdometerAlert = () => (
  <div className="odometer-alert ch-mt--2">
    <div className="odometer-alert-content">
      The engine must be running when you update these.
    </div>
  </div>
);

export default OdometerAlert;
